__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "alef-messaging-pages";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@alefeducation/ui-elements-library-core", "0.86.11", () => (Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(852), __webpack_require__.e(77), __webpack_require__.e(495), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(94)]).then(() => (() => (__webpack_require__(77495))))));
			register("@alefeducation/ui-elements-library-icons", "0.68.0", () => (Promise.all([__webpack_require__.e(287), __webpack_require__.e(599), __webpack_require__.e(422), __webpack_require__.e(428)]).then(() => (() => (__webpack_require__(7599))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(422)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-modal", "3.16.3", () => (Promise.all([__webpack_require__.e(312), __webpack_require__.e(422), __webpack_require__.e(94)]).then(() => (() => (__webpack_require__(20312))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(422), __webpack_require__.e(682), __webpack_require__.e(6)]).then(() => (() => (__webpack_require__(54625))))));
			register("react-router", "5.2.0", () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(180), __webpack_require__.e(422), __webpack_require__.e(587)]).then(() => (() => (__webpack_require__(24180))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(205), __webpack_require__.e(422), __webpack_require__.e(968)]).then(() => (() => (__webpack_require__(83205))))));
			register("react", "16.14.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(852), __webpack_require__.e(35), __webpack_require__.e(422)]).then(() => (() => (__webpack_require__(99035))))));
			initExternal(19999);
			initExternal(44894);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};